import { render, staticRenderFns } from "./VBoolean.vue?vue&type=template&id=9b9bd7b6&scoped=true"
import script from "./VBoolean.vue?vue&type=script&lang=js"
export * from "./VBoolean.vue?vue&type=script&lang=js"
import style0 from "./VBoolean.vue?vue&type=style&index=0&id=9b9bd7b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9bd7b6",
  null
  
)

export default component.exports